import { render, staticRenderFns } from "./OffCanvasDetailsTuoteryhma.vue?vue&type=template&id=dd9f013e&scoped=true&"
import script from "./OffCanvasDetailsTuoteryhma.vue?vue&type=script&lang=js&"
export * from "./OffCanvasDetailsTuoteryhma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9f013e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd9f013e')) {
      api.createRecord('dd9f013e', component.options)
    } else {
      api.reload('dd9f013e', component.options)
    }
    module.hot.accept("./OffCanvasDetailsTuoteryhma.vue?vue&type=template&id=dd9f013e&scoped=true&", function () {
      api.rerender('dd9f013e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OffCanvasDetailsTuoteryhma.vue"
export default component.exports